<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="결제 내역 조회"
      desc="결제내역 현황을 조회할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="status" slot-scope="props">{{ props.item.is_cancel ? '결제취소' : '결제완료' }}</div>

      <div slot="pay_status" slot-scope="props" v-html="payStatus(props.item)"></div>

      <div slot="price" slot-scope="props">{{ props.item.price | currency }}</div>

      <div slot="bill" slot-scope="props">
        {{ props.item.bill? props.item.bill.bill: '' }}
      </div>

      <div slot="is_cancel" slot-scope="props">
        <button class="button half is-danger" v-if="ableCancel(props.item)" @click="cancel(props.item.id)">취소</button>
        <!--<button class="btn half is-danger" v-if="!props.item.is_cancel">완료</button>-->
        <div v-else-if="props.item.is_cancel">-</div>
      </div>
    </admin-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>결제를 취소하겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="cancelModal">취소</button>
          <button class="button is-primary" @click="confirmModal">확인</button>
        </div>
      </div>
    </modal>

    <!--<sweet-modal ref="cancelModal">
      <div>결제를 취소하겠습니까?</div>
      <div class="btn-group-justify-end">
        <button class="button is-light" @click="cancelModal">취소</button>
        <button class="button is-primary" @click="confirmModal">확인</button>
      </div>
    </sweet-modal>-->

  </div>
</template>

<script>
  import moment from 'moment'
  import LpSortDropDown from '../../../module/common/LpSortDropDown'
  import LpInputText from '../../../module/common/LpInputText'
  import LpRadio from '../../../module/common/LpRadio'
  import { SweetModal } from 'sweet-modal-vue'
  import LpModal from '../../../module/common/LpModal.vue'
  import AdminFilter from "../../../module/admin/AdminFilter";
  import AdminTable from "../../../module/admin/AdminTable";
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'PaymentList',
    layout:'Main',
    mixins: [
      ListMixin
    ],
    props: ['page'],
    components: {
      AdminTable,
      AdminFilter,
      SweetModal, LpSortDropDown,
      LpInputText, LpRadio, LpModal,
    },
    data () {
      return {
        id: 0
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('bill_payment', 'launchpack/bill/payment');
      },
      getDataFromServer() {
        this.getData();
      },
      cancel(id){
        this.id = id;
        //this.$refs.cancelModal.open();
        this.$modal.show('cancelModal');
      },
      cancelModal(){
        //this.$refs.cancelModal.close();
        this.$modal.hide('cancelModal');
      },
      confirmModal(){
        this.$axios.post('admin/launchpack/bill/cancel', {
          id: this.id
        }).then(res=>{
          if(res.status===200){
            this.toast('결제가 취소되었습니다.');
            this.$modal.hide('cancelModal');
            this.initializing('bill_payment', 'launchpack/bill/payment');
          }
        }).catch(error=>{
          if (error.response) {
            if (error.response.data.message) {
              this.toast(error.response.data.message);
            } else {
              this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
            }
          }
        })
      },
      ableCancel(item) {
        let arr = findArray(this.tableItems, 'is_cancel', true);
        if(!item.is_cancel) {
          if(item.pay_method==='VBank') return false
          return find(arr, 'tid', item.tid) ? false : true;
        }
        else
          return false;
      },
      payStatus(item) {
        let text = '';
        if(item.bill) text = '빌링결제';
        else {
          text = `단건결제 <br> ${item.pay_method_kor}`
        }
        return text;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'



</style>
